var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.pageLoading,
          expression: "pageLoading",
        },
      ],
      ref: "page",
      staticClass: "page",
      style:
        "height:" +
        (_vm.isModalTable && _vm.isCalculateHeight ? _vm.modalPageHeight : ""),
    },
    [
      _vm.searchList && _vm.searchList.length > 0
        ? _c(
            "div",
            { ref: "search", staticClass: "page-search" },
            [
              _c(
                "vxe-form",
                {
                  attrs: {
                    data: _vm.formData,
                    titleWidth: _vm.configs.formConfig.titleWidth,
                    titleAlign: _vm.configs.formConfig.titleAlign,
                  },
                  on: {
                    submit: _vm.searchEvent,
                    "toggle-collapse": _vm.toggleCollapse,
                    reset: _vm.searchEvent,
                  },
                },
                [
                  _vm._l(_vm.searchList, function (item, key) {
                    return _c(
                      "vxe-form-item",
                      _vm._b(
                        {
                          key: key,
                          attrs: {
                            title: item.label,
                            "item-render": item.render,
                          },
                        },
                        "vxe-form-item",
                        item,
                        false
                      ),
                      [
                        item.render.type === "customSearch"
                          ? [
                              _c(item.render.typeName, {
                                tag: "component",
                                attrs: {
                                  formData: _vm.formData,
                                  value: _vm.formData[item.render.field],
                                },
                                on: {
                                  getCustomData: (val) =>
                                    _vm.getCustomData(item.render, val),
                                },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                  _c("vxe-form-item", {
                    attrs: {
                      span: _vm.searchSpan,
                      align: "right",
                      "collapse-node": _vm.checkShowCollapseButton(),
                      "item-render": {
                        name: "ElButtons",
                        children: [
                          {
                            content: "查询",
                            props: {
                              type: "primary",
                              nativeType: "submit",
                              icon: "el-icon-search",
                              size: "small",
                            },
                          },
                          {
                            content: "重置",
                            props: {
                              nativeType: "reset",
                              icon: "el-icon-refresh",
                              size: "small",
                            },
                          },
                        ],
                      },
                    },
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      (_vm.configs.toolBarConfig && _vm.configs.toolBarConfig.length) ||
      _vm.personalSetting
        ? _c(
            "div",
            { staticClass: "page-toolbar" },
            [
              _c("vxe-toolbar", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "buttons",
                      fn: function () {
                        return [
                          _vm._l(
                            _vm.configs.toolBarConfig.slice(0, _vm.btnNum),
                            function (item, index) {
                              return _c(
                                "span",
                                {
                                  key: index,
                                  staticStyle: {
                                    "margin-left": "10px",
                                    background: "transparent",
                                  },
                                },
                                [
                                  item.code !== "personal_setting"
                                    ? _c(
                                        "el-button",
                                        {
                                          key: index,
                                          attrs: {
                                            size: item.size || "small",
                                            icon: item.icon,
                                            type: item.buttonType,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.buttonClick({
                                                val: item,
                                              })
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.name) + " ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }
                          ),
                          _vm.personalSetting
                            ? _c(
                                "el-dropdown",
                                {
                                  ref: "dropdown",
                                  staticStyle: {
                                    "margin-left": "10px",
                                    background: "transparent",
                                  },
                                  attrs: {
                                    trigger: "click",
                                    "hide-on-click": "",
                                  },
                                },
                                [
                                  _c("el-button", [
                                    _vm._v(_vm._s(_vm.personalSetting.name)),
                                  ]),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-flow": "column",
                                            padding: "0 10px",
                                          },
                                        },
                                        [
                                          _vm._t("default", function () {
                                            return [
                                              _c("PersonalSetting", {
                                                attrs: {
                                                  headerFunctionCode:
                                                    _vm.headerFunctionCode,
                                                  parentCode:
                                                    _vm.tableParentCode,
                                                },
                                                on: {
                                                  changeColumns:
                                                    _vm.changeColumns,
                                                },
                                              }),
                                            ]
                                          }),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.configs.toolBarConfig.length > _vm.btnNum
                            ? _c(
                                "el-dropdown",
                                { staticStyle: { "margin-left": "10px" } },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "primary" } },
                                    [_vm._v("更多")]
                                  ),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-flow": "column",
                                            padding: "0 10px",
                                          },
                                        },
                                        _vm._l(
                                          _vm.configs.toolBarConfig.slice(
                                            _vm.btnNum
                                          ),
                                          function (item, index) {
                                            return _c(
                                              "span",
                                              { key: index },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    key: index,
                                                    staticStyle: {
                                                      margin: "5px 0 0 0",
                                                    },
                                                    attrs: {
                                                      size:
                                                        item.size || "small",
                                                      icon: item.icon,
                                                      type: item.buttonType,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.buttonClick({
                                                          val: item,
                                                        })
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.name) + " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.configs.columns
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              staticClass: "page-table",
            },
            [
              _c(
                "vxe-table",
                _vm._b(
                  {
                    ref: "xTable",
                    staticClass: "mytable-scrollbar",
                    attrs: {
                      "row-class-name": _vm.tableRowClassName,
                      "header-row-class-name": _vm.tableHeaderClassName,
                      size: "mini",
                      editConfig: _vm.editConfig,
                      rowId:
                        _vm.configs.tableConfig &&
                        (_vm.configs.tableConfig.idKey || "id"),
                      data: _vm.tableData,
                      "tree-config": {
                        ...this.handleTreeConfig(),
                        loadMethod: _vm.loadChildrenMethod,
                      },
                      height: _vm.isCalculateHeight ? _vm.tableHeight : "",
                    },
                    on: {
                      "checkbox-change": _vm.checkboxChange,
                      "checkbox-all": _vm.checkboxAll,
                      "radio-change": _vm.radioChange,
                      "cell-click": _vm.cellClick,
                      "edit-actived": _vm.editActivedEvent,
                    },
                  },
                  "vxe-table",
                  _vm.configs.tableConfig,
                  false
                ),
                _vm._l(_vm.configs.columns, function (item, index) {
                  return _c(
                    "vxe-table-column",
                    _vm._b(
                      {
                        key: index,
                        attrs: {
                          cellRender: item.cellRender,
                          "tree-node": item.treeNode,
                          "min-width": item.minWidth || 100,
                        },
                        scopedSlots: _vm._u(
                          [
                            item.buttons
                              ? {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      item.noShowMore
                                        ? _c(
                                            "div",
                                            { staticClass: "inline-block" },
                                            _vm._l(
                                              item.buttons,
                                              function (btn, k) {
                                                return _c("div", { key: k }, [
                                                  _vm.clickVisible({
                                                    val: btn,
                                                    row,
                                                  })
                                                    ? _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                            name: btn.code,
                                                          },
                                                          on: {
                                                            click: (val) =>
                                                              _vm.clickCell({
                                                                val: btn,
                                                                row,
                                                              }),
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                type: "text",
                                                              },
                                                              on: {
                                                                click: (val) =>
                                                                  _vm.clickCell(
                                                                    {
                                                                      val: btn,
                                                                      row,
                                                                    }
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  btn.name
                                                                ) + " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ])
                                              }
                                            ),
                                            0
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "setting-btn" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "inline-block" },
                                                _vm._l(
                                                  item.buttons.slice(0, 1),
                                                  function (btn, k) {
                                                    return _c(
                                                      "div",
                                                      { key: k },
                                                      [
                                                        _vm.clickVisible({
                                                          val: btn,
                                                          row,
                                                        })
                                                          ? _c(
                                                              "div",
                                                              {
                                                                attrs: {
                                                                  type: "text",
                                                                  name: btn.code,
                                                                },
                                                                on: {
                                                                  click: (
                                                                    val
                                                                  ) =>
                                                                    _vm.clickCell(
                                                                      {
                                                                        val: btn,
                                                                        row,
                                                                      }
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    attrs: {
                                                                      type: "text",
                                                                    },
                                                                    on: {
                                                                      click: (
                                                                        val
                                                                      ) =>
                                                                        _vm.clickCell(
                                                                          {
                                                                            val: btn,
                                                                            row,
                                                                          }
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        btn.name
                                                                      ) + " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                              item.buttons.length > 1 &&
                                              _vm.clickVisible({
                                                val: "divider",
                                                row,
                                              })
                                                ? _c("el-divider", {
                                                    attrs: {
                                                      direction: "vertical",
                                                    },
                                                  })
                                                : _vm._e(),
                                              item.buttons.length === 2
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "inline-block",
                                                    },
                                                    _vm._l(
                                                      item.buttons.slice(1, 2),
                                                      function (btn, k) {
                                                        return _c(
                                                          "div",
                                                          { key: k },
                                                          [
                                                            _vm.clickVisible({
                                                              val: btn,
                                                              row,
                                                            })
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    attrs: {
                                                                      type: "text",
                                                                      name: btn.code,
                                                                    },
                                                                    on: {
                                                                      click: (
                                                                        val
                                                                      ) =>
                                                                        _vm.clickCell(
                                                                          {
                                                                            val: btn,
                                                                            row,
                                                                          }
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          type: "text",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            (
                                                                              val
                                                                            ) =>
                                                                              _vm.clickCell(
                                                                                {
                                                                                  val: btn,
                                                                                  row,
                                                                                }
                                                                              ),
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            btn.name
                                                                          ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                              item.buttons.length > 2 &&
                                              _vm.clickVisible({ val: "", row })
                                                ? _c(
                                                    "el-dropdown",
                                                    {
                                                      on: {
                                                        command: (val) =>
                                                          _vm.clickCell({
                                                            val,
                                                            row,
                                                          }),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "el-dropdown-link",
                                                        },
                                                        [
                                                          _vm._v(" 更多"),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-arrow-down el-icon--right",
                                                          }),
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-dropdown-menu",
                                                        {
                                                          attrs: {
                                                            slot: "dropdown",
                                                          },
                                                          slot: "dropdown",
                                                        },
                                                        _vm._l(
                                                          item.buttons.slice(
                                                            1,
                                                            item.buttons.length
                                                          ),
                                                          function (btn, k) {
                                                            return _c(
                                                              "div",
                                                              { key: k },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    attrs: {
                                                                      name: btn.code,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.clickCell(
                                                                            {
                                                                              val: btn,
                                                                              row,
                                                                            }
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm.clickVisible(
                                                                      {
                                                                        val: btn,
                                                                        row,
                                                                      }
                                                                    )
                                                                      ? _c(
                                                                          "el-dropdown-item",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                command:
                                                                                  btn,
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  btn.name
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                    ]
                                  },
                                }
                              : item.dictCode
                              ? {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getDictCode(
                                              row[item.field],
                                              item.dictCode
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                }
                              : null,
                          ],
                          null,
                          true
                        ),
                      },
                      "vxe-table-column",
                      item,
                      false
                    )
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", [
        _c("div", { staticClass: "summary-title" }, [_vm._v("汇总信息")]),
        _c(
          "div",
          [
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "summary-item" }, [
                    _vm._v(
                      "SAP数量: " +
                        _vm._s(_vm.summaryData.sapQuantity || 0) +
                        " "
                    ),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "summary-item" }, [
                    _vm._v(
                      "验收数量: " +
                        _vm._s(_vm.summaryData.acceptanceQuantity || 0) +
                        " "
                    ),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "summary-item" }, [
                    _vm._v(
                      "数量差异: " +
                        _vm._s(_vm.summaryData.compareQuantity || 0) +
                        " "
                    ),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "summary-item" }, [
                    _vm._v(
                      "SAP总金额（含税）: " +
                        _vm._s(_vm.summaryData.sapAmount || 0) +
                        " "
                    ),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "summary-item" }, [
                    _vm._v(
                      "验收金额（含税）: " +
                        _vm._s(_vm.summaryData.acceptanceAmount || 0) +
                        " "
                    ),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "summary-item" }, [
                    _vm._v(
                      "金额差异（含税）: " +
                        _vm._s(_vm.summaryData.compareAmount || 0) +
                        " "
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm.tableData.length > 0 &&
      _vm.configs.columns &&
      (typeof _vm.configs.pagination === "undefined" ||
        (typeof _vm.configs.pagination !== "undefined" &&
          _vm.configs.pagination))
        ? _c(
            "div",
            {
              staticClass: "page-pageination",
              class: _vm.isCalculateHeight ? "bottom-pageination" : "",
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.tablePage.currentPage,
                  "page-sizes": _vm.paginationSize,
                  "page-size": _vm.tablePage.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  align: "right",
                  total: _vm.tablePage.totalResult || _vm.tableData.length,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.modalName
        ? _c(_vm.modalName, {
            ref: "modalName",
            tag: "component",
            attrs: {
              modalConfig: _vm.modalConfig,
              visible: _vm.modalConfig.visible,
              rules: _vm.configs.rule,
              formConfig: _vm.formConfig,
              propsObj: _vm.propsObjInData,
              "modal-form-data": _vm.modalFormData,
            },
            on: {
              "update:modalConfig": function ($event) {
                _vm.modalConfig = $event
              },
              "update:modal-config": function ($event) {
                _vm.modalConfig = $event
              },
              "update:visible": function ($event) {
                return _vm.$set(_vm.modalConfig, "visible", $event)
              },
              "update:rules": function ($event) {
                return _vm.$set(_vm.configs, "rule", $event)
              },
              submit: _vm.onSubmit,
              onClose: _vm.closeModal,
              onGetList: _vm.getList,
              onGetSelect: _vm.onGetSelect,
              "load-complete": _vm.formLoadComplete,
              "update:modalFormData": function ($event) {
                _vm.modalFormData = $event
              },
              "update:modal-form-data": function ($event) {
                _vm.modalFormData = $event
              },
            },
          })
        : _c(
            "Modal",
            {
              attrs: {
                modalConfig: _vm.modalConfig,
                visible: _vm.modalConfig.visible,
              },
              on: {
                "update:modalConfig": function ($event) {
                  _vm.modalConfig = $event
                },
                "update:modal-config": function ($event) {
                  _vm.modalConfig = $event
                },
                onClose: _vm.closeModal,
                onOk: _vm.onModalOk,
                "update:visible": function ($event) {
                  return _vm.$set(_vm.modalConfig, "visible", $event)
                },
              },
            },
            [
              _c(_vm.formName, {
                ref: "modalForm",
                tag: "component",
                attrs: {
                  rules: _vm.configs.rule,
                  formConfig: _vm.formConfig,
                  modalConfig: _vm.modalConfig,
                  propsObj: _vm.propsObjInData,
                  "modal-form-data": _vm.modalFormData,
                },
                on: {
                  "update:rules": function ($event) {
                    return _vm.$set(_vm.configs, "rule", $event)
                  },
                  submit: _vm.onSubmit,
                  onClose: _vm.closeModal,
                  onGetList: _vm.getList,
                  resetTree: _vm.resetTree,
                  onGetSelect: _vm.onGetSelect,
                  "load-complete": _vm.formLoadComplete,
                  "update:modalFormData": function ($event) {
                    _vm.modalFormData = $event
                  },
                  "update:modal-form-data": function ($event) {
                    _vm.modalFormData = $event
                  },
                },
              }),
              _vm.modalConfig.showFooter
                ? _c(
                    "div",
                    { staticClass: "dialog-footer" },
                    [
                      _vm._t("footer", function () {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { icon: "el-icon-check", type: "primary" },
                              on: { click: _vm.onModalOk },
                            },
                            [_vm._v("确定")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { icon: "el-icon-close", type: "danger" },
                              on: { click: _vm.closeModal },
                            },
                            [_vm._v("取消")]
                          ),
                        ]
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }